function modulateTableAdapter(fieldIdx: number) {
    const fieldsNames = ["otherCompensationFund0", "afiliatedMonths0", "otherCompensationFund1", "afiliatedMonths1"];
    return fieldsNames.map((fieldName: string, idx: number) => {
        const newIdx = fieldIdx + idx;
        return {
            id: newIdx,
            name: fieldName,
            type: "",
            label: "",
            disabled: false,
            hidden: true,
            helperText: "",
            helperTextUriText: "",
            helperTextUri: "",
            help: "Ayuda campo",
            acceptedFileTypes: "",
            options: [].map((option: any, optionIdx: number) => ({
              id: optionIdx,
              label: option,
              value: option
            }))
          }
    })
   
    }
    
    export default modulateTableAdapter;